export default function getFrequencyFromCron(cron: string): string {
  switch (cron) {
    case "0 0 * * *": // At midnight every day
      return "Daily";
    case "0 0 * * 0": // At midnight every Sunday
      return "Weekly";
    case "0 0 1 * *": // At midnight on the first day of every month
      return "Monthly";
    default:
      return "Daily";
    //   throw new Error('Invalid frequency');
  }
}
